import { channelService } from "Apis";
import { useProjectSharedState } from "./useSharedState";
import {
  ApiChannel,
  ApiProject,
} from "@incendium/api";

const fetchChannels = async (project: ApiProject) => {
  const channels = await channelService.channelServiceListChannels({
    projectId: project.id as number,
  });
  return channels.results || [];
};

export const useChannels = () => {
  const { state, setState, loading, fetched } = useProjectSharedState(
    "channels",
    [],
    fetchChannels
  );

  return {
    channels: state as ApiChannel[],
    setChannels: setState as React.Dispatch<React.SetStateAction<ApiChannel[]>>,
    loading,
    fetched,
  };
};
